var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-row",
        { staticClass: "zIndex" },
        [
          _c(
            "el-col",
            { staticClass: "col1", class: { errorMapa: _vm.errors.length } },
            [
              _c("appMapa", {
                ref: "mapa",
                attrs: {
                  idMapa: _vm.idMapa,
                  height: "65vh",
                  mapLayersConfigs: _vm.layers,
                  featureLayerConfig: _vm.featureLayerConfig,
                  buttons: _vm.buttonsConfig,
                  configButtonsCamadas: _vm.configButtonsCamadas,
                  isAdicionandoPonto: _vm.isAdicionandoPonto,
                  configOrtoFotos: _vm.configOrtoFotos
                },
                on: {
                  removerGeometria: _vm.removerGeometria,
                  changeIsAdicionandoPonto: _vm.changeIsAdicionandoPonto,
                  adicionarPonto: _vm.adicionarPonto
                }
              }),
              _c("app-resumable", {
                ref: "resumable",
                attrs: {
                  target: _vm.urlUpload,
                  fileType: _vm.validExtensions,
                  idInput: "upload",
                  fileTypeErrorCallback: _vm.fileTypeErrorCallback
                },
                on: {
                  onSuccess: _vm.onSuccess,
                  onError: _vm.onError,
                  onProgress: _vm.onProgress,
                  fileAdded: _vm.onFileAdded
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45daa305", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45daa305","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/MapaRetificacao.vue
// module id = null
// module chunks = 